<template>
  <v-app class="site-app">
    <a class="skip-link" href="#main-content">Zum Inhalt</a>
    <Navbar v-if="!isImageAdmin" />
    <main
      id="main-content"
      ref="main"
      class="page-content"
      :class="{
        'legal-page': ['impressum', 'datenschutz'].includes($route.name),
        'admin-page': isImageAdmin,
      }"
      tabindex="-1"
    >
      <router-view v-slot="{ Component }">
        <transition name="page" mode="out-in" @after-enter="focusPage">
          <component :is="Component" :key="$route.path" />
        </transition>
      </router-view>
    </main>
    <Footer v-if="!isImageAdmin" />
  </v-app>
</template>
<script setup>
import { computed, ref } from 'vue';
import { useRoute } from 'vue-router';
import Navbar from '@/components/layout/Navbar.vue';
import Footer from '@/components/layout/Footer.vue';
import '@/styles/site.css';
const main = ref(null);
const route = useRoute();
const isImageAdmin = computed(() => route.name === 'adminImageView');
const focusPage = () => main.value?.focus({ preventScroll: true });
</script>
<style>
.page-content.admin-page {
  padding-top: 0;
}
</style>
